var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcdConnectEmoji11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 162.71C128.52 162.71 162.7 128.53 162.7 86.36C162.7 44.19 128.52 10 86.35 10C44.18 10 10 44.18 10 86.35C10 128.52 44.18 162.7 86.35 162.7",
    fill: "#FF5C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1423 107.527C89.7923 107.587 93.4623 109.987 93.5423 113.917C93.6223 117.837 89.6623 120.247 86.1423 120.307C82.4923 120.367 78.8223 117.757 78.7423 113.917C78.6623 109.997 82.6223 107.587 86.1423 107.527C89.1923 107.477 89.2023 102.737 86.1423 102.787C79.8723 102.887 74.1323 107.367 74.0023 113.917C73.8623 120.467 80.0923 124.947 86.1423 125.047C92.4123 125.147 98.1523 120.307 98.2823 113.917C98.4223 107.367 92.2023 102.887 86.1423 102.787C83.0823 102.737 83.0923 107.477 86.1423 107.527Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 81.2601C55.4 89.6601 48.59 96.4601 40.2 96.4601C31.81 96.4601 25 89.6501 25 81.2601C25 72.8701 31.81 66.0601 40.2 66.0601C48.59 66.0601 55.4 72.8701 55.4 81.2601Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.74 76.3699C44.74 78.8399 42.7401 80.8399 40.2701 80.8399C37.8001 80.8399 35.8 78.8399 35.8 76.3699C35.8 73.8999 37.8001 71.8999 40.2701 71.8999C42.7401 71.8999 44.74 73.8999 44.74 76.3699Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.72 81.2601C147.72 89.6601 140.91 96.4601 132.52 96.4601C124.13 96.4601 117.32 89.6501 117.32 81.2601C117.32 72.8701 124.13 66.0601 132.52 66.0601C140.91 66.0601 147.72 72.8701 147.72 81.2601Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.07 76.3699C137.07 78.8399 135.07 80.8399 132.6 80.8399C130.13 80.8399 128.13 78.8399 128.13 76.3699C128.13 73.8999 130.13 71.8999 132.6 71.8999C135.07 71.8999 137.07 73.8999 137.07 76.3699Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.11 109.42C51.11 113.69 46.45 117.16 40.7 117.16C34.95 117.16 30.29 113.7 30.29 109.42C30.29 105.14 34.95 101.68 40.7 101.68C46.45 101.68 51.11 105.14 51.11 109.42Z",
    fill: "#FFD525"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.42 109.42C142.42 113.69 137.76 117.16 132.01 117.16C126.26 117.16 121.6 113.7 121.6 109.42C121.6 105.14 126.26 101.68 132.01 101.68C137.76 101.68 142.42 105.14 142.42 109.42Z",
    fill: "#FFD525"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8196 62.9468C34.533 61.7397 44.2367 60.53 53.9527 59.3132C55.2387 59.1505 56.3173 58.3318 56.3119 56.9224C56.3075 55.741 55.2044 54.4101 53.9211 54.5632C44.2077 55.7703 34.5013 56.9897 24.7879 58.1968C23.502 58.3595 22.4233 59.1782 22.4287 60.5877C22.4331 61.7691 23.5363 63.0999 24.8196 62.9468Z",
    fill: "#1C1C1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.923 58.2075C138.209 57.0003 128.505 55.7906 118.799 54.5713C117.513 54.4086 116.422 55.7465 116.408 56.9305C116.403 58.3399 117.481 59.1586 118.767 59.3213L147.891 62.9575C149.177 63.1202 150.268 61.7823 150.282 60.5983C150.287 59.1889 149.208 58.3702 147.923 58.2075Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcdConnectEmoji11);
export default __webpack_public_path__ + "static/media/ECD_Connect_emoji11.a7a3cf32.svg";
export { ForwardRef as ReactComponent };